// nikEncryption.js
import CryptoJS from "crypto-js";

// Sama persis dengan Spring: hanya pakai 16 karakter pertama
const FULL_SECRET = "ThisIsASecretKey123";
const SECRET_KEY = FULL_SECRET.substring(0, 16); // "ThisIsASecretKe"


export function encryptNik(plainNik) {
    const encrypted = CryptoJS.AES.encrypt(plainNik, CryptoJS.enc.Utf8.parse(SECRET_KEY), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString(); // hasil base64
}

export function decryptNik(encryptedNik) {
    try {
        if (!encryptedNik) {
            console.warn("Data NIK terenkripsi kosong.");
            return "";
        }

        const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: CryptoJS.enc.Base64.parse(encryptedNik) },
            CryptoJS.enc.Utf8.parse(SECRET_KEY),
            {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
            }
        );

        return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (error) {
        console.error("Gagal mendekripsi NIK:", error.message);
        return "";
    }
}
